import { Buffer3384y49aj0pxr as Buffer } from './Buffer.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var RealBufferedSinkClass;
function RealBufferedSink() {
  if (RealBufferedSinkClass === VOID) {
    class $ {
      constructor(sink) {
        this.f40_1 = sink;
        this.g40_1 = false;
        this.h40_1 = new (Buffer())();
      }
      w3v(source, byteCount) {
        // Inline function 'okio.internal.commonWrite' call
        // Inline function 'kotlin.check' call
        if (!!this.g40_1) {
          var message = 'closed';
          throw IllegalStateException().o(toString(message));
        }
        this.h40_1.w3v(source, byteCount);
        this.i40();
        return Unit_instance;
      }
      m3z(byteString) {
        // Inline function 'okio.internal.commonWrite' call
        // Inline function 'kotlin.check' call
        if (!!this.g40_1) {
          var message = 'closed';
          throw IllegalStateException().o(toString(message));
        }
        this.h40_1.m3z(byteString);
        return this.i40();
      }
      o3z(string) {
        // Inline function 'okio.internal.commonWriteUtf8' call
        // Inline function 'kotlin.check' call
        if (!!this.g40_1) {
          var message = 'closed';
          throw IllegalStateException().o(toString(message));
        }
        this.h40_1.o3z(string);
        return this.i40();
      }
      p3z(string, beginIndex, endIndex) {
        // Inline function 'okio.internal.commonWriteUtf8' call
        // Inline function 'kotlin.check' call
        if (!!this.g40_1) {
          var message = 'closed';
          throw IllegalStateException().o(toString(message));
        }
        this.h40_1.p3z(string, beginIndex, endIndex);
        return this.i40();
      }
      q3z(b) {
        // Inline function 'okio.internal.commonWriteByte' call
        // Inline function 'kotlin.check' call
        if (!!this.g40_1) {
          var message = 'closed';
          throw IllegalStateException().o(toString(message));
        }
        this.h40_1.q3z(b);
        return this.i40();
      }
      i40() {
        // Inline function 'okio.internal.commonEmitCompleteSegments' call
        // Inline function 'kotlin.check' call
        if (!!this.g40_1) {
          var message = 'closed';
          throw IllegalStateException().o(toString(message));
        }
        var byteCount = this.h40_1.x3y();
        if (byteCount > 0n) {
          this.f40_1.w3v(this.h40_1, byteCount);
        }
        return this;
      }
      lc() {
        // Inline function 'okio.internal.commonFlush' call
        // Inline function 'kotlin.check' call
        if (!!this.g40_1) {
          var message = 'closed';
          throw IllegalStateException().o(toString(message));
        }
        if (this.h40_1.y3v_1 > 0n) {
          this.f40_1.w3v(this.h40_1, this.h40_1.y3v_1);
        }
        this.f40_1.lc();
        return Unit_instance;
      }
      l6() {
        var tmp$ret$0;
        $l$block: {
          // Inline function 'okio.internal.commonClose' call
          if (this.g40_1) {
            tmp$ret$0 = Unit_instance;
            break $l$block;
          }
          var thrown = null;
          try {
            if (this.h40_1.y3v_1 > 0n) {
              this.f40_1.w3v(this.h40_1, this.h40_1.y3v_1);
            }
          } catch ($p) {
            if ($p instanceof Error) {
              var e = $p;
              thrown = e;
            } else {
              throw $p;
            }
          }
          try {
            this.f40_1.l6();
          } catch ($p) {
            if ($p instanceof Error) {
              var e_0 = $p;
              if (thrown == null)
                thrown = e_0;
            } else {
              throw $p;
            }
          }
          this.g40_1 = true;
          if (!(thrown == null))
            throw thrown;
          tmp$ret$0 = Unit_instance;
        }
        return tmp$ret$0;
      }
      toString() {
        // Inline function 'okio.internal.commonToString' call
        return 'buffer(' + toString(this.f40_1) + ')';
      }
    }
    initMetadataForClass($, 'RealBufferedSink');
    RealBufferedSinkClass = $;
  }
  return RealBufferedSinkClass;
}
//region block: exports
export {
  RealBufferedSink as RealBufferedSinkipqv3pv5gqfq,
};
//endregion

//# sourceMappingURL=RealBufferedSink.mjs.map
